export const createGraph = (startDate: string, days: number) => {
  const graph = [];
  let date = new Date(startDate);
  for (let i = 0; i < days; i++) {
    graph.push({
      date: new Date(date),
      value: Math.floor(Math.random() * 10) + 1
    });
    date.setDate(date.getDate() + 1);
  }
  return graph;
};

export const generateTrendGraph = (
  startDate: string,
  days: number,
  trend: "rising" | "falling"
) => {
  const graph = [];
  let date = new Date(startDate);
  const slope = trend === "rising" ? 1 : -1; // Change 1 to a different value to adjust the steepness of the trend
  for (let i = 0; i < days; i++) {
    // Base value is determined by the slope and the current day index
    const baseValue = i * slope;
    // Randomness is added to the base value to make the graph look more natural
    const value = baseValue + (Math.random() * 2 - 1); // Change 2 to a different value to adjust the amount of randomness
    graph.push({ date: new Date(date), value: Math.max(0, value) }); // Ensure the value is never negative
    date.setDate(date.getDate() + 1);
  }
  return graph;
};
